export default "__VITE_ASSET__vS$UcSaW__"